import {Request} from './Request';

/**
 *
 */
export class UnlockConnectorRequest implements Request {
    private connectorId: number;
    chargePointSelectList: string[];

    constructor(chargePointSelectList: string[], connectorId?: number) {
        this.connectorId = connectorId;
        this.chargePointSelectList = chargePointSelectList;
    }

    public toString = (): string => {
        return `UnlockConnectorRequest (connectorId: ${this.connectorId},
        chargePointSelectList: ${this.chargePointSelectList})`;
    }

    get connector_id(): number {
        return this.connectorId;
    }

    set connector_id(value: number) {
        this.connectorId = value;
    }
}
